import React from "react";

import { InputPopoverContext } from "@components/organisms/inputPopover/inputPopoverContext";

export function useInputPopoverContext() {
  const context = React.useContext(InputPopoverContext);

  if (context == null) {
    throw new Error(
      "InputPopover components must be wrapped in <InputPopover />",
    );
  }

  return context;
}
